import * as React from 'react';

import * as styles from './Ratings.css';
import { EStarSize, EStarTheme, Star, getPrettyFloat } from '@cian/frontend-reviews-components';
import { ArticleParagraph2, UIHeading4 } from '@cian/ui-kit';

export interface IReviewLinkProps {
  reviewCountText: string;
  totalRate: number;
  reviewCount: number;
}

export function Ratings({ reviewCountText, totalRate, reviewCount }: IReviewLinkProps) {
  if (reviewCount === 0) {
    return (
      <div className={styles['ratings']}>
        <Star size={EStarSize.M} theme={EStarTheme.NotFilled} />
        <ArticleParagraph2 color="gray60_100">{reviewCountText}</ArticleParagraph2>
      </div>
    );
  }

  return (
    <div className={styles['ratings']}>
      <div className={styles['ratings__label']}>
        <UIHeading4 color="decorative-orange" fontWeight="700">
          {getPrettyFloat(totalRate)}
        </UIHeading4>
      </div>
      <div className={styles['ratings__star']}>
        <Star size={EStarSize.M} theme={EStarTheme.Filled} />
      </div>
      <div className={styles['reviews']}>
        <ArticleParagraph2 color="gray60_100">{reviewCountText}</ArticleParagraph2>
      </div>
    </div>
  );
}
